// 対象要素を取得
var $root = $('#headerSearch');
var $panel = $root.find('.panel');
var $open = $root.find('.open');
var $close = $root.find('.close');
/**
 * 関数定義
 */
// 初期化処理

var init = function init() {
  var panelId = 'headerSearchPanel';
  var buttonId = 'headerSearchButton'; // デフォルトの属性およびクラスを設定

  $panel.attr({
    'aria-hidden': 'true',
    'id': panelId,
    'aria-labelledby': buttonId
  });
  $open.attr({
    'aria-expanded': 'false',
    'id': buttonId,
    'aria-controls': panelId
  });
}; // 表示切替


var switchDisplay = function switchDisplay(e) {
  // ステートに応じてボタンとパネルの属性値を変更
  if ($open.attr('aria-expanded') === 'false') {
    // 閉じている
    // クリックしたボタンと該当するパネルを開く
    $open.attr('aria-expanded', 'true');
    $panel.attr('aria-hidden', 'false');
  } else {
    // 開いている
    $open.attr('aria-expanded', 'false');
    $panel.attr('aria-hidden', 'true');
  }

  e.stopPropagation(); // 親要素へのバブリングを停止

  e.preventDefault(); // 要素の標準イベントを停止
}; // パネルを閉じる


var closePanel = function closePanel(e) {
  $open.attr('aria-expanded', 'false');
  $panel.attr('aria-hidden', 'true');
};
/**
 * 初期化処理
 */


init();
/**
 * イベント設定
 */
// トリガとなるメニューボタンクリック時に表示切替のメソッドを実行

$open.on('click', switchDisplay);
$close.on('click', closePanel);